document.addEventListener('DOMContentLoaded', function() {
  var sectionEl = document.querySelector('[id^="tabbed-sliders-"]');
  if (!sectionEl) return;

  var tabs = sectionEl.querySelectorAll('.tab-button');
  var contents = sectionEl.querySelectorAll('.tab-content');

  tabs.forEach(function(tabBtn) {
    tabBtn.addEventListener('click', function() {
      var targetTab = this.getAttribute('data-tab');

      tabs.forEach(function(t) { t.classList.remove('active'); });
      contents.forEach(function(c) { c.style.display = 'none'; });

      this.classList.add('active');
      var activeContent = sectionEl.querySelector('.tab-content[data-tab-content="'+ targetTab +'"]');
      if (activeContent) activeContent.style.display = 'block';

      var swiperInstance = window['swiperTab' + targetTab];
      if (swiperInstance) {
        swiperInstance.update();
        swiperInstance.slideTo(0);
      }
    });
  });

  var commonOptions = {
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 20,
    loop: true,
    observer: true,
    observeParents: true,
    //slidesOffsetBefore: 10,  <--- extra space on the left
    //slidesOffsetAfter:  10,  // <--- extra space on the right
    pagination: { clickable: true },
    navigation: {},
    breakpoints: {
    // Tablet & up (992px+)
    992: {
      slidesPerView: 1.1 
    }
  }
};

  window.swiperTab1 = new Swiper(sectionEl.querySelector('.swiper-container-tab1'), Object.assign({}, commonOptions, {
    pagination: { el: sectionEl.querySelector('.swiper-pagination-tab1'), clickable: true },
    navigation: {
      nextEl: sectionEl.querySelector('.swiper-button-next-tab1'),
      prevEl: sectionEl.querySelector('.swiper-button-prev-tab1')
    }
  }));

  window.swiperTab2 = new Swiper(sectionEl.querySelector('.swiper-container-tab2'), Object.assign({}, commonOptions, {
    pagination: { el: sectionEl.querySelector('.swiper-pagination-tab2'), clickable: true },
    navigation: {
      nextEl: sectionEl.querySelector('.swiper-button-next-tab2'),
      prevEl: sectionEl.querySelector('.swiper-button-prev-tab2')
    }
  }));

  window.swiperTab3 = new Swiper(sectionEl.querySelector('.swiper-container-tab3'), Object.assign({}, commonOptions, {
    pagination: { el: sectionEl.querySelector('.swiper-pagination-tab3'), clickable: true },
    navigation: {
      nextEl: sectionEl.querySelector('.swiper-button-next-tab3'),
      prevEl: sectionEl.querySelector('.swiper-button-prev-tab3')
    }
  }));
});
